import { INCONSISTENT_ACCESS_CREDENTIALS } from '../../../login/src/api/validateSession.js';
import { onRegisterSession } from '../../../login/src/form/onRegisterSession.js';
import progressBar from '../../../shared/DOM/progressBar.js';
import { decodeB64WithEncoding } from '../../../shared/api/base64/decodeB64WithEncoding.js';
import { executeEnrollmentStep } from '../api/executeEnrollmentStep.js';
import { checkShowErrorOtp } from './checkShowErrorOtp.js';
import { showMessageFinish } from './showMessageFinish.js';

/**
 * Enrollment finish: lógica distinta por la redirección app/login
 *
 * @param {*} tokena
 * @param {*} user
 * @param {*} domain
 * @param {*} group
 * @param {*} stepNum
 * @param {*} stepData
 */
export async function executeFinish(tokena, user, domain, group, stepNum, stepData) {
  try {
    progressBar.loading();
    const ediwinResult = await executeEnrollmentStep(tokena, user, stepNum, stepData);
    if (!ediwinResult?.result || !ediwinResult?.outputData?.token) {
      throw new Error(ediwinResult?.message || 'global.error-occurred');
    }

    // Sin await no se capturaría con el catch
    await onRegisterSession({ user, domain, group }, decodeB64WithEncoding(ediwinResult.outputData.token));
    progressBar.resolved();
  } catch (error) {
    progressBar.rejected();

    // Problemas con acceso OTP
    if (error?.message === INCONSISTENT_ACCESS_CREDENTIALS) {
      showMessageFinish(user, domain, group, stepNum);
    } else {
      checkShowErrorOtp(error);
      throw error;
    }
  }
}
